// Comprehensive polyfills for SimplePeer and other Node.js dependencies
// This must be imported BEFORE any other imports in the app

// Process polyfill
if (typeof window !== 'undefined') {
  if (!window.process) {
    (window as any).process = {};
  }
  
  const process = (window as any).process;
  
  // Add missing properties
  if (!process.env) process.env = {};
  if (!process.nextTick) {
    process.nextTick = (fn: Function, ...args: any[]) => {
      Promise.resolve().then(() => fn(...args));
    };
  }
  if (!process.version) process.version = '';
  if (!process.versions) process.versions = {};
  if (!process.cwd) process.cwd = () => '/';
  if (!process.browser) process.browser = true;
}

// Global polyfill
if (typeof window !== 'undefined' && typeof global === 'undefined') {
  (window as any).global = window;
}

// Buffer polyfill (minimal)
if (typeof window !== 'undefined' && typeof window.Buffer === 'undefined') {
  (window as any).Buffer = {
    isBuffer: () => false,
    concat: () => Buffer.alloc(0),
    alloc: (size: number) => new Uint8Array(size)
  };
}

export {};
